module.exports = __webpack_public_path__ + "static/media/five.a4ec8589.jpg";